<template>
    <div>
        <v-hover v-slot="{ isHovering, props }">
            <v-card class="my-2" :elevation="isHovering ? 4 : 2" :tile="false" v-bind="props" transition="fade-transition">
                <v-card-title>
                </v-card-title>
                <v-card-text>
                    <v-list-item :key="avaliacao.id" :subtitle="avaliacao.email" :title="avaliacao.nome">
                        <template v-slot:prepend>
                            <v-avatar color="primary-darken-1">
                                <v-icon color="white">mdi-account</v-icon>
                            </v-avatar>
                        </template>

                        <template v-slot:append>
                            <v-btn
                                @click="atualiza_dados_colaborador({id: avaliacao.id})"
                                :loading="StateRHLoading.includes(`update-colaborador-rm-${avaliacao.id}`)"
                                color="success"
                                icon
                                title="Atualizar dados do Colaborador nesta avaliacão."
                                variant="text">
                                <v-icon>mdi-refresh</v-icon>
                            </v-btn>
                            <v-btn
                                :loading="StateRHLoading.includes(`reenvio-notificacao-tempo-casa-${avaliacao.id}`)"
                                :color="avaliacao.enviado_colab && avaliacao.enviado_gestor ? 'success': 'error'"
                                icon
                                :title="`Envio de notificação Gestor/Colaborador. Gestor(${avaliacao.enviado_gestor?'ok':'não enviado'}). Colaborador(${avaliacao.enviado_colab?'ok':'não enviado'})`"
                                variant="text">
                                <v-icon>{{avaliacao.enviado_colab && avaliacao.enviado_gestor ? 'mdi-email-check': 'mdi-email-check'}}</v-icon>
                                <v-menu activator="parent">
                                    <v-list>
                                        <v-list-item @click="EnviarNotificacaoAvaliacaoTempoCasa({id: avaliacao.id, nivel: 'COLAB' })">
                                            <v-list-item-title>Reenviar para Colaborador</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item @click="EnviarNotificacaoAvaliacaoTempoCasa({id: avaliacao.id, nivel: 'GESTOR' })">
                                            <v-list-item-title>Reenviar para Gestor</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-btn>
                            <v-btn 
                                icon="mdi-account-tie"
                                :loading="StateRHLoading.includes(`update-avaliacao-tempo-casa-${avaliacao.id}`)"
                                :color="avaliacao.concluido_colab ? 'success': 'error'"
                                title="Avaliação do colaborador concluída"
                                @click="marcar_concluido({id: avaliacao.id, concluido_colab: true })"
                                variant="text">
                            </v-btn>
                            <v-btn 
                                icon="mdi-account-tie-hat"
                                :loading="StateRHLoading.includes(`update-avaliacao-tempo-casa-${avaliacao.id}`)"
                                :color="avaliacao.concluido_gestor ? 'success': 'error'"
                                title="Avaliação do gestor concluída"
                                @click="marcar_concluido({id: avaliacao.id, concluido_gestor: true })"
                                variant="text">
                            </v-btn>
                            <v-btn v-if="avaliacao.observacoes"
                                color="warning"
                                icon="mdi-information"
                                variant="text"
                                @click="showObs(avaliacao.observacoes)"
                            ></v-btn>
                            <modal-gdb :code="'modal_aval_'+avaliacao.id" :ref="'modal_aval_'+avaliacao.id"
                                :no-actions="true"
                                :persistent="false"
                                toolbar-title="Detalhes do colaborador">
                                <template v-slot:activate-slot>
                                    <v-btn color="grey"
                                        icon="mdi-card-account-details"
                                        variant="text"
                                    ></v-btn>
                                </template>
                                <template v-slot:body>
                                    <v-row class="nmp">
                                        <v-col cols="12" sm="12" class="text-subtitle-2">
                                            <div>Registrado em: {{$verify.formatarData(avaliacao.created_at)}}</div>
                                            <v-divider class="my-2"></v-divider>
                                            <h3>Colaborador</h3>
                                            <div>Admissão em: {{$verify.formatarData(avaliacao.dataadmissao)}}</div>
                                            <div>CPF: {{avaliacao.cpf}}</div>
                                            <div>Chapa: {{avaliacao.chapa}}</div>
                                            <div>Raiz: {{avaliacao.secao_raiz}}</div>
                                            <div>Seção: {{avaliacao.secao}}</div>
                                            <div>Função: {{avaliacao.funcao}}</div>
                                            
                                            <v-divider class="my-2"></v-divider>
                                            <h3>Gestor</h3>
                                            <div>Gestor: {{avaliacao.gestor_nome}}</div>
                                            <div>E-mail: {{avaliacao.gestor_email}}</div>

                                            <v-divider class="my-2"></v-divider>
                                            <h3>Observações</h3>
                                            <code>{{avaliacao.observacoes}}</code>
                                        </v-col>
                                    </v-row>
                                </template>
                            </modal-gdb>
                            <v-btn icon color="primary"
                                title="Classificador de tempo de casa"
                                >
                                {{ avaliacao.tag }}
                            </v-btn>
                        </template>
                    </v-list-item>
                </v-card-text>
            </v-card>
        </v-hover>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        avaliacao: {
            required: true
        }
    },
    methods: {
        ...mapActions(['EnviarNotificacaoAvaliacaoTempoCasa','UpdateAvaliacoesTempoCasa', 'UpdateColabadorDoRm']),
        async marcar_concluido(data){
            const confirma = confirm('Deseja marcar como concluído?')
            if (!confirma) return

            await this.UpdateAvaliacoesTempoCasa(data)
            this.$emit('on-updated', true)
        },
        async atualiza_dados_colaborador(data){
            const confirma = confirm('Deseja atualizar dados do colaborador com os dados RM?')
            if (!confirma) return

            await this.UpdateColabadorDoRm(data)
            this.$emit('on-updated', true)
        },
        showObs(obs){
            alert(obs)
        }
    },
    computed: {
        ...mapGetters(['StateRHLoading'])
    }
}
</script>